import {clickEvent} from "../../../webpack/modules/events";

let imageZoomOpening = false;

clickEvent('#product-page .images-zoom-popup', true, function (element, event) {
    let target = event.target;

    if (target.classList.contains('add-item-wish-list') || target.closest('.add-item-wish-list')) return;
    if (target.classList.contains('open-ar-modal') || target.closest('.open-ar-modal')) return;
    if (imageZoomOpening) return;

    imageZoomOpening = true;
    setTimeout(() => { imageZoomOpening = false; }, 1500);

    let productId = element.closest('.product-scope').dataset.productId;
    let position = element.dataset.position;

    import(/* webpackChunkName: "popup-image-zoom" */ '../../../webpack/modules-optimized/popup-image-zoom').then(({showImageZoomPopup}) => {
        showImageZoomPopup(productId, Number(position));
    }).catch(function() {
        imageZoomOpening = false;
    });
});
